// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/showRecord/approve-commonet.scss
// module id = 4147
// module chunks = 50